var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-4",
    transform: "translate(-636.000000, -522.000000)",
    fill: "#444444",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(349.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(17.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.103231,5.73219713 C266.190622,5.64524748 266.331855,5.64524748 266.419246,5.73219713 L266.419246,5.73219713 L269.268712,8.58131676 C269.355672,8.66869723 269.355672,8.80991258 269.268712,8.89729306 L269.268712,8.89729306 L264.380484,13.7849264 C264.225309,13.9398472 264.027605,14.0451841 263.812457,14.0875704 L263.812457,14.0875704 L260.536305,14.9915026 C260.389517,15.0204473 260.237949,14.9744445 260.132022,14.8687975 C260.026095,14.7631505 259.979703,14.6117179 260.00828,14.4662087 L260.00828,14.4662087 L260.910989,11.1877879 C260.95338,10.9726668 261.05873,10.7749861 261.21367,10.6198305 L261.21367,10.6198305 Z M268.812691,3.29771307 C269.21167,2.90076231 269.856445,2.90076231 270.255425,3.29771307 L270.255425,3.29771307 L271.703492,4.74827094 C272.098836,5.14476389 272.098836,5.78633704 271.703492,6.18283 L271.703492,6.18283 L270.947457,6.94010653 C270.867453,7.02010053 270.739447,7.02010053 270.659443,6.94010653 L270.659443,6.94010653 L268.060656,4.3389683 C267.981317,4.2593648 267.981317,4.13059341 268.060656,4.05098991 L268.060656,4.05098991 Z",
    id: "Combined-Shape"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.1f1a99227d63ba3819020a409709ca5a.svg";
export { ForwardRef as ReactComponent };